import { WeighingTypeEnum } from "./model-enums";

export class WeighingType {
  type: WeighingTypeEnum;

  constructor(type: string) {
    switch (type) {
      case WeighingTypeEnum.Initial:
        this.type = WeighingTypeEnum.Initial;
        break;
      case WeighingTypeEnum.Interim:
        this.type = WeighingTypeEnum.Interim;
        break;
      case WeighingTypeEnum.Final:
        this.type = WeighingTypeEnum.Final;
        break;
      default:
        throw new Error('Invalid WeighingType: ' + type);
    }
  }
}
